import {useIsDebugMode} from './useIsDebugMode';

// Feature guard - flip to always-on for release
export function useIsInTransitEnabled(): boolean {
	return useIsDebugMode();
}
